
import Vue from 'vue';
import marked from 'marked';

export default Vue.extend({
  name: 'MarkedRenderer',
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    renderedHtml() {
      try {
        if (!this.value || this.value.trim() === '') {
          return '<p>Content is not available.</p>';
        }
        
        // Use marked v4+ API
        return marked.parse(this.value, {
          sanitize: true,
          baseUrl: window.location.origin
        });
      } catch (error) {
        console.error('Markdown rendering error:', error);
        return '<p>Error loading content. Please try refreshing the page.</p>';
      }
    },
  },
});
